// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_511c993","eachWay":"_5d6ef9b"};